import { useQuery } from '@tanstack/react-query';
import { useNostr } from '@nostrify/react';
import { MUSIC_TRACK_KIND, parseMusicTrack } from '@/lib/musicTypes';

export function useMusicTrack(pubkey: string, trackId: string, relays?: string[]) {
  const { nostr } = useNostr();

  return useQuery({
    queryKey: ['music-track', pubkey, trackId, relays],
    queryFn: async (c) => {
      const signal = AbortSignal.any([c.signal, AbortSignal.timeout(3000)]);
      
      // Connect to multiple relays for better discovery
      const relayList = relays || [
        'wss://relay.ditto.pub',
        'wss://relay.nostr.band',
        'wss://relay.damus.io',
        'wss://nos.lol',
      ];
      
      const relayGroup = nostr.group(relayList);
      
      const events = await relayGroup.query(
        [{
          kinds: [MUSIC_TRACK_KIND],
          authors: [pubkey],
          '#d': [trackId],
        }],
        { signal }
      );

      if (events.length === 0) return null;

      return parseMusicTrack(events[0]);
    },
    enabled: !!pubkey && !!trackId,
  });
}
